import { getGoogleMapsUrl } from '@/components/map/googleMaps';

export interface MapPoint {
  name: string | null;
  lat: number | null;
  lon: number | null;
}

export interface MapsLinkItem {
  label: string;
  href: string;
  title: string;
}

interface LocatedMapPoint extends MapPoint {
  lat: number;
  lon: number;
}

const hasLocation = (point: MapPoint): point is LocatedMapPoint =>
  point.lat !== null && point.lon !== null;

export function getPlaceMapsLink(label: string, point: MapPoint): MapsLinkItem | null {
  if (!hasLocation(point)) return null;

  return {
    label,
    href: getGoogleMapsUrl(point.lat, point.lon),
    title: `Open ${point.name ?? 'this place'} in Google Maps`,
  };
}
